import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_EXISTING_SUBDIMENSIONS_REQUEST } from "../actions/fetchExistingSubdimensionsActions";

import {
  fetchExistingSubdimensionsSuccess,
  fetchExistingSubdimensionsFailure,
} from "../actions/fetchExistingSubdimensionsActions";

import { fetchExistingSubdimensionsApi } from "../../../services/accIqService";

function* fetchExistingSubdimensionsSaga(action) {
  try {
    const response = yield call(
      fetchExistingSubdimensionsApi,
      action.payload // contains user_id, user_role, client, competitor_name
    );
    yield put(fetchExistingSubdimensionsSuccess(response));
  } catch (error) {
    yield put(
      fetchExistingSubdimensionsFailure(
        error.response?.data?.message || "Failed to fetch subdimensions"
      )
    );
  }
}

export function* watchFetchExistingSubdimensions() {
  yield takeLatest(
    FETCH_EXISTING_SUBDIMENSIONS_REQUEST,
    fetchExistingSubdimensionsSaga
  );
}
